export function concatArrays(...args) {
    const totalSize = args.reduce((size, value) => size + value.length, 0);
    const result = new Uint8Array(totalSize);
    let offset = 0;
    args.forEach((value) => {
        result.set(value, offset);
        offset += value.length;
    });
    return result;
}
/**
 * Create chunk from an array
 * @param input data to split
 * @param chunkSize chunk size (>= 1)
 */
export function chunkArray(input, chunkSize) {
    if (chunkSize < 1) {
        throw new Error(`Invalid parameter 'chunkSize' for 'chunkArray()' method, it must be a least 1 but given ${chunkSize}`);
    }
    const length = Math.ceil(input.length / chunkSize);
    return Array.from(Array(length), (_, i) => input.slice(i * chunkSize, i * chunkSize + chunkSize));
}
export function uniqFilter(value, index, self) {
    return self.indexOf(value) === index;
}
// export function chunkArrayLike<T>(typedArray: Iterable<T> | ArrayLike<T>, chunkSize: number) {
//     return chunkArray(Array.from(typedArray), chunkSize).map(
//         value => Uint8Array.from(value)
//     );
// }
